import {normalizeStorageUrl} from '@ui/utils/urls/normalize-storage-url';

const ASSET_URL = import.meta.env.VITE_ASSET_URL || 'https://kscolta.corsica/';

export function withAssetUrl(path?: string | null): string {
  if (!path) return '';

  const storagePath = normalizeStorageUrl(path);
  if (storagePath !== path) return storagePath;

  // deja absolu: on ne touche pas
  if (/^(https?:|blob:|data:)/.test(path)) {
    return path;
  }

  // normaliser pour eviter le doublon de slash
  const normalized = path.replace(/^\/+/, '');

  return ASSET_URL.replace(/\/+$/, '') + '/' + normalized;
}
